import request from '@/utils/request'

// 获取所有数据
export function getDashboardData(data) {
  return request({
    url: '/device/huang-mei-datav/get-data',
    method: 'post',
    data
  })
}

// 获取单个商户的收购详情
export function getMerchantOrder(data) {
  return request({
    url: '/device/huang-mei-datav/get-mer-order-detail',
    method: 'post',
    data
  })
}

// 获取某个乡镇的农户数据
export function getTownData(data) {
  return request({
    url: '/device/huang-mei-datav/get-cun-nonghu-list',
    method: 'post',
    data
  })
}

// 获取某个村的农户数据
export function getVillageData(data) {
  return request({
    url: '/device/huang-mei-datav/get-cun-nonghu-detail',
    method: 'post',
    data
  })
}
